import styled from "styled-components";
import { borderRadius, rawColors, spacing, typographyMixin } from "@magicbi/ui-library";
import type { RunCellStatus } from "../RunStrip/RunStrip.types";
import { RUN_SOLID } from "../RunStrip/RunStrip.styles";

/** Heatmap cells: OK reads soft green, the rest are solid. */
export const HEAT_COLOR: Record<RunCellStatus, string> = {
  ...RUN_SOLID,
  ok: rawColors.accent.greenLight,
  none: rawColors.structural[50],
};

export const Grid = styled.div<{ $columns: number }>`
  display: grid;
  grid-template-columns: minmax(0, max-content) repeat(${({ $columns }) => $columns}, minmax(1.5rem, 3.5rem));
  column-gap: ${spacing[1.5]};
  row-gap: ${spacing[1.5]};
  align-items: center;
`;

export const DayHead = styled.span<{ $current: boolean }>`
  ${typographyMixin("caption", 3)}
  text-align: center;
  color: ${({ theme }) => theme.colors.text.secondary};
  font-weight: ${({ $current }) => ($current ? 700 : 400)};
  ${({ $current, theme }) => ($current ? `color: ${theme.colors.text.primary};` : "")}
`;

export const RowLabel = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${spacing[2]};
  padding-right: ${spacing[3]};
  ${typographyMixin("body", 4)}
  color: ${({ theme }) => theme.colors.text.primary};
  white-space: nowrap;
`;

export const Cell = styled.span<{ $status: RunCellStatus }>`
  display: block;
  height: 1.5rem;
  border-radius: ${borderRadius.sm};
  background-color: ${({ $status }) => HEAT_COLOR[$status]};
  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1);
`;

export const Legend = styled.ul`
  grid-column: 1 / -1;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: ${spacing[4]};
  margin: ${spacing[2]} 0 0;
  padding: 0;
  list-style: none;
  ${typographyMixin("caption", 3)}
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const LegendItem = styled.li`
  display: inline-flex;
  align-items: center;
  gap: ${spacing[1.5]};
`;

export const Swatch = styled.span<{ $status: RunCellStatus }>`
  width: 0.5rem;
  height: 0.5rem;
  border-radius: ${borderRadius.sm};
  background-color: ${({ $status }) => HEAT_COLOR[$status]};
`;
